<template>
  <ul class="links-list">
    <li
      v-for="link in links"
      :key="link.id"
      class="links-list__item"
    >
      <BurgerLink
        class="links-list__link"
        :link="link"
        @click-menu-item="$emit('click-menu-item', $event)"
      />
    </li>
  </ul>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BurgerLink from '~/components/TheHeader/Burger/BurgerLink.vue';
  import type { ILink } from '~/components/ArrowMenu/ArrowMenu';
  export default defineNuxtComponent({
    name: 'BurgerLinksList',
    components: {
      BurgerLink,
    },

    props: {
      links: {
        type: Array as PropType<ILink[]>,
        required: true,
      },
    },

    emits: ['click-menu-item'],
  });
</script>

<style lang="scss" scoped></style>
